import React from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  CloseButton,
} from '@chakra-ui/react';
import CButton from './CButton';

function ConfirmDialog({ isOpen, onClose, onConfirm, header, message, position = 'center', isDelete = true }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={position === 'center'}>
      <ModalOverlay />
      <ModalContent
        mx="4"
        mt={position === 'top' ? '10vh' : undefined}
        mb={position === 'bottom' ? '10vh' : undefined}
      >
        <ModalHeader display="flex" justifyContent="space-between" alignItems="center">
          {header || 'Confirm Action'}
          <CloseButton onClick={onClose} />
        </ModalHeader>
        <ModalBody>
          <Text>{message || 'Are you sure you want to proceed?'}</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            mr={3}
            variant="ghost"
            bg="gray"
            color="white"
            borderRadius='10px'
            _hover={{ bg: 'gray.600' }}
            onClick={onClose}
          >
            Cancel
          </Button>
          {
            isDelete ? (
              <Button
                colorScheme='red'
                borderRadius='10px'
                onClick={onConfirm}>
                Confirm
              </Button>
            ) : (
              <CButton
                onClick={onConfirm}
                width={'100px'}
              >
                Confirm
              </CButton>
            )
          }
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ConfirmDialog;
